import { css } from '@emotion/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

const Base = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const StyledButton = styled.button<{
  isDisabled?: boolean
  isDark?: boolean
  size?: string
}>`
  ${Base};
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background: ${({ isDark }) => (isDark ? theme.token.var('colors.green.a200') : theme.token.var('colors.green.a150'))};
  border-radius: ${theme.token.var('borderRadius.extraSmall')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
`

export const StyledLink = styled.a<{
  isDisabled?: boolean
  isDark?: boolean
  size?: string
}>`
  ${Base};
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background: ${({ isDark }) => (isDark ? theme.token.var('colors.green.a200') : theme.token.var('colors.green.a150'))};
  border-radius: ${theme.token.var('borderRadius.extraSmall')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
`
